import { Controller } from "@hotwired/stimulus"
import { post } from '@rails/request.js'
import { debounce } from "lodash"

// Connects to data-controller="auto-request"
export default class extends Controller {
  static values = { url: String, turboStreamId: String }

  declare urlValue: string
  declare turboStreamIdValue: string

  prevValue: string

  connect() {
    this.call = debounce(this.call, 300)
    this.call()
  }

  call() {
    const currentElement = this.element as HTMLInputElement
    if(this.prevValue === currentElement.value) return

    post(this.urlValue, {
      body: {
        amount: currentElement.value,
        turbo_stream_id: this.turboStreamIdValue },
      responseKind: 'turbo-stream'
    })
    this.prevValue = currentElement.value
  }
}
